<template>
  <div>
    <div v-if="tiles.length">
      <h3 class="mb-4">
        今募集中のテーマ
      </h3>
      <v-row :style="$mq !== 'sp' ? 'width:100%' : 'width:100vw'">
        <v-col
          :cols="$mq !== 'sp' ? 4 : 6"
          v-for="item in tiles"
          :key="item.id"
          style="padding:4px"
        >
          <v-card
            class="ma-0 pa-1 rounded-lg flex"
            color="#F5F5F5"
            @click="
              () => {
                if (inSetting) {
                  editTile(item);
                } else if (item && item.isPopup) {
                  imgpopupInit(item);
                } else {
                  moveToUrl(item.toUrl);
                }
              }
            "
          >
            <div class="d-flex" style="aspect-ratio: 1">
              <v-img
                v-if="item.contents[0].imgUrl"
                :src="item.contents[0].imgUrl"
                class="my-auto"
                style="width:100% !important;max-height:100% !important;"
              ></v-img>
              <v-img
                v-else
                src="../assets/png/1106.png"
                class="my-auto"
                style="width:100% !important;max-height:100% !important;"
              ></v-img>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="imgpopup" v-if="$mq !== 'sp'">
        <v-card class="flex overflow-hidden">
          <v-row>
            <v-col class="d-flex flex-column ma-0 pa-8" cols="6">
              <v-carousel
                hide-delimiters
                height="auto"
                v-if="contents.length > 0"
                v-model="imgIndex"
              >
                <template v-slot:prev="{ on, attrs }">
                  <v-btn
                    icon
                    @click="imgIndexCount(-1)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon>mdi-arrow-left-circle</v-icon></v-btn
                  >
                </template>
                <template v-slot:next="{ on, attrs }">
                  <v-btn
                    icon
                    @click="imgIndexCount(+1)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon>mdi-arrow-right-circle</v-icon></v-btn
                  >
                </template>
                <v-carousel-item
                  v-for="(item, i) in contents"
                  :key="i"
                  :src="item.imgUrl"
                  width="100%"
                ></v-carousel-item>
              </v-carousel>
              <div v-else class="d-flex" style="height:440px;">
                <p class="mx-auto my-auto">画像未登録</p>
              </div>
              <v-row
                class="d-flex"
                v-if="contents.length > 0"
              >
                <v-col
                  v-for="(item, i) in contents"
                  :key="i"
                  class="my-2 mx-auto pa-2"
                  cols="2"
                  @click="imgIndex = i"
                >
                  <v-img
                    v-if="item && item.imgUrl"
                    :src="item.imgUrl"
                    aspect-ratio="1"
                  ></v-img>
                  <div v-else style="height:50px;"></div>
                  <p>{{ i + 1 }}枚目</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-8" cols="6">
              <div class="flex flex-column" style="height:100%; width:100%;">
                <div class="d-flex my-2" style="width:100%;">
                  <h2 class="mx-auto">{{ title }}</h2>
                  <v-icon class="ml-auto" @click="imgpopup = false"
                    >mdi-close</v-icon
                  >
                </div>
                <v-card
                  class="overflow-y-auto"
                  v-if="contents[imgIndex] && contents[imgIndex].text"
                >
                  <v-card-text>{{ contents[imgIndex].text }}</v-card-text>
                </v-card>
                <div v-else class="d-flex" style="height:340px;">
                  <p class="mx-auto my-auto">テキスト未登録</p>
                </div>
                <div class="d-flex" style="width:100%;">
                  <v-btn
                    class="mt-6 mx-auto deepAqua white--text"
                    @click="moveToUrl(toUrl)"
                  >
                    {{ toName }}
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-else v-model="imgpopup" width="100vw" fullscreen>
        <v-card class="d-flex flex-column overflow-hidden px-4">
          <div class="d-flex my-2" style="width:100%;">
            <h2 class="mx-auto">{{ title }}</h2>
            <v-icon class="ml-auto" @click="imgpopup = false">mdi-close</v-icon>
          </div>
          <v-carousel
            class="px-4"
            hide-delimiters
            height="auto"
            v-if="contents.length > 0"
            v-model="imgIndex"
          >
            <template v-slot:prev="{ on, attrs }">
              <v-btn icon @click="imgIndexCount(-1)" v-bind="attrs" v-on="on"
                ><v-icon>mdi-arrow-left-circle</v-icon></v-btn
              >
            </template>
            <template v-slot:next="{ on, attrs }">
              <v-btn icon @click="imgIndexCount(+1)" v-bind="attrs" v-on="on"
                ><v-icon>mdi-arrow-right-circle</v-icon></v-btn
              >
            </template>
            <v-carousel-item
              v-for="(item, i) in contents"
              :key="i"
              :src="item.imgUrl"
              width="100%"
            ></v-carousel-item>
          </v-carousel>
          <div v-else class="d-flex" style="height:200px;">
            <p class="mx-auto my-auto">画像未登録</p>
          </div>
          <v-row
            class="d-flex px-2"
            v-if="contents.length > 0"
          >
            <v-col
              v-for="(item, i) in contents"
              :key="i"
              class="my-2 mx-auto pa-1"
              cols="2"
              @click="imgIndex = i"
            >
              <v-img
                v-if="item && item.imgUrl"
                :src="item.imgUrl"
                aspect-ratio="1"
              ></v-img>
              <div v-else class="text-center" style="height:50px;">なし</div>
              <p class="mb-0 text-center">{{ i + 1 }}枚目</p>
            </v-col>
          </v-row>
          <v-card
            class="mx-4 overflow-y-auto"
            height="auto"
            v-if="contents[imgIndex] && contents[imgIndex].text"
          >
            <v-card-text>{{ contents[imgIndex].text }}</v-card-text>
          </v-card>
          <div v-else class="d-flex" style="height:340px;">
            <p class="mx-auto my-auto">テキスト未登録</p>
          </div>
          <v-btn
            class="my-3 mx-auto deepAqua white--text"
            @click="moveToUrl(toUrl)"
          >
            {{ toName }}
          </v-btn>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-if="isAdmin" v-model="setTileModifyMode">
      <v-card class="d-flex flex-column overflow-hidden">
        <div class="d-flex my-2" style="width:100%;">
          <h2 class="mx-auto">タイル設定</h2>
          <v-icon class="ml-auto" @click="setTileModifyMode = false"
            >mdi-close</v-icon
          >
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="リンク先URL"
                v-model="toUrl"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="リンク先名"
                v-model="toName"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <!--ホーム画面に複数の画像を表示するポップアップを表示する-->
            <v-card-text
              style="font-size:18px; color:#707070"
              class="pl-2 pb-0"
            >
              ホーム画面に複数の画像を表示するポップアップを表示する
            </v-card-text>
            <v-card-actions class="pl-2 py-0">
              <v-radio-group v-model="isPopup" row>
                <v-radio label="する" value="true"></v-radio>
                <v-radio label="しない" value="false"></v-radio>
              </v-radio-group>
            </v-card-actions>
            <v-col cols="12" v-if="isPopup == 'true'">
              <v-text-field
                label="タイトル"
                v-model="title"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-card-text
              style="font-size:18px; color:#707070"
              class="pl-2 pb-0"
            >
              登録する画像
            </v-card-text>
            <v-card-actions class="pl-2 py-0">
              <v-row cols="2" v-if="isPopup == 'true'">
                <v-col
                  v-for="(item, index) in contents"
                  :key="index + 'tileImg'"
                >
                  <div style="display: flex;justify-content: space-between;">
                    <p class="mb-0 cloud--text">{{ index + 1 }}枚目</p>
                    <v-btn
                      v-if="contents.length > 1"
                      @click="contents.splice(index, 1)"
                      class=""
                      x-small
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                  <v-card height="125px">
                    <upImage_tile
                      :key="tileId + index + contents[index].imgUrl"
                      :num="index"
                      :tileId="tileId"
                      :uploadedUrl="contents[index].imgUrl"
                      @changeContents="changeContents"
                    ></upImage_tile>
                  </v-card>
                  <v-card class="mt-1 overflow-y-auto" height="125px">
                    <v-textarea
                      outlined
                      v-model="contents[index].text"
                      hide-details
                    ></v-textarea>
                  </v-card>
                </v-col>
                <v-btn
                  @click="contents.push({ text: '', imgUrl: '' })"
                  :disabled="!contents.every((c) => c.imgUrl)"
                  class="mx-auto mt-4"
                  color="#008CFF"
                  rounded
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
              <v-row cols="2" v-else-if="isPopup == 'false'">
                <v-col>
                  <p class="mb-0 cloud--text">1枚目</p>
                  <v-card height="125px">
                    <upImage_tile
                      :key="tileId"
                      :num="0"
                      :tileId="tileId"
                      :uploadedUrl="contents[0] && contents[0].imgUrl"
                      @changeContents="changeContents"
                    ></upImage_tile>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-actions>

            <v-card-text
              v-if="inSetting"
              style="font-size:18px; color:#707070"
              class="pl-2 pb-0"
            >
              タイルの削除
            </v-card-text>
            <v-card-actions v-if="inSetting" class="pl-2 py-0">
              <v-btn
                rounded
                class="white--text deepLava px-4 my-2"
                @click="checkRemoveTile = true"
                style="text-decoration:none;"
              >
                タイルの削除
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                color="#008CFF"
                class="white--text px-8"
                @click="(setTileModifyMode = false), addTile()"
                :disabled="!contents.every((c) => c.imgUrl)"
              >
                {{ inSetting ? "編集完了" : "登録" }}
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="checkRemoveTile" height="90%" width="40%">
      <v-card color="white" class="pa-6">
        <p class="font-weight-bold py-2 text-h5 text-center">
          <font color="black">タイルの削除</font>
        </p>
        <p class="pt-2 text-center">
          <font color="black">本当にこのタイルを削除しますか？</font>
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip class="mr-4" @click="checkRemoveTile = false">
            削除しない
          </v-chip>
          <v-chip
            @click="(checkRemoveTile = false), removeTile()"
            color="deepLava"
            dark
          >
            削除する
          </v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn v-if="tileEnabled && isAdmin" @click="openAddTile()" class="mt-4">
      タイルの追加
    </v-btn>
  </div>
</template>

<script>
import firebase from "firebase";
const upImage_tile = () => import("../components/upImage_tile.vue");
import Vue from "vue";
import VueMq from "vue-mq";

Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sp: 959,
    pc: 960,
  },
  defaultBreakpoint: "pc", // customize this for SSR
});
export default {
  name: "tile",
  props: {
    wsId: {
      type: String || undefined,
      default: "",
    },
    inSetting: {
      type: Boolean,
      default: false,
    },
    tileEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    upImage_tile,
  },
  data() {
    return {
      setTileModifyMode: false,
      checkRemoveTile: false,
      isPopup: "false",
      tiles: [],
      tileId: "",
      imgpopup: false,
      title: "",
      contents: [],
      toUrl: "",
      toName: "",
      imgIndex: 0,
    };
  },
  mounted() {
    this.getTiles();
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
  },
  methods: {
    getTiles() {
      let self = this;
      const wsId = this.wsId;
      this.tiles = [];
      if (!this.tileEnabled) return; // ""の場合はワークスペースがあるLiqlidでのトップのため、非表示
      firebase
        .firestore()
        .collection("0")
        .doc("config")
        .collection("tiles")
        .where("isActive", "==", true)
        .where("wsId", "==", wsId ?? "")
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.tiles.push({
              id: doc.id,
              ...doc.data(),
            });
          });
        });
    },
    imgIndexCount(i) {
      this.imgIndex = (this.imgIndex + i) % this.contents.length;
      if (this.imgIndex < 0) this.imgIndex = this.contents.length - 1;
    },
    imgpopupInit(item) {
      this.contents = item.contents.map((el) => {
        return { ...el };
      });
      this.title = item.title;
      this.toUrl = item.toUrl;
      this.toName = item.toName;
      this.imgpopup = true;
    },
    moveToUrl(url) {
      const urlObject = new URL(url);
      // hostが同じでないなら、外部リンクとして別タブで開き、同じであればrouter.pushで移動
      this.imgpopup = false;
      if (urlObject.host !== window.location.host) {
        window.open(url, "_blank");
      } else {
        if (url.includes('channel=')) {
          // アンケートを表示したいため routerを使わずに遷移
          window.location.href = url;
        }
        this.$router.push(urlObject.pathname);
      }
    },
    openAddTile() {
      this.tileId = firebase
        .firestore()
        .collection("0")
        .doc("config")
        .collection("tiles")
        .doc().id;
      this.setTileModifyMode = true;
      this.contents = [{ text: "", imgUrl: "" }];
    },
    editTile(item) {
      this.tileId = item.id;
      this.setTileModifyMode = true;
      this.contents = item.contents.map((el) => {
        return { ...el };
      });
      this.title = item.title;
      this.toUrl = item.toUrl;
      this.toName = item.toName;
      this.isPopup = item.isPopup.toString();
    },
    addTile() {
      firebase
        .firestore()
        .collection("0")
        .doc("config")
        .collection("tiles")
        .doc(this.tileId)
        .set(
          {
            title: this.title,
            toUrl: this.toUrl,
            toName: this.toName,
            wsId: this.wsId ?? "",
            isActive: true,
            isPopup: this.isPopup == "true",
            contents: this.contents,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          },
          { merge: true }
        )
        .then(() => {
          this.setTileModifyMode = false;
          this.getTiles();
        });
    },
    // upImage_tileからemitする関数
    changeContents(index, url) {
      this.contents[index].imgUrl = url;
    },
    removeTile() {
      firebase
        .firestore()
        .collection("0")
        .doc("config")
        .collection("tiles")
        .doc(this.tileId)
        .update({
          isActive: false,
        })
        .then(() => {
          this.checkRemoveTile = false;
          this.setTileModifyMode = false;
          this.getTiles();
        });
    },
  },
};
</script>

<style></style>
